import React from 'react'
import classnames from 'classnames'
import styles from './index.module.less'

export default function ProductTitle(props: {
  tabItemTitleBg?: string
  tabBarActiveTextColor: string
  title: string
  tabItemTitleLeftBg: string
  tabItemTitleRightBg: string
  titleBgImgType?: number
}) {
  const {
    tabItemTitleBg,
    tabBarActiveTextColor,
    tabItemTitleLeftBg,
    tabItemTitleRightBg,
    title,
    titleBgImgType,
  } = props
  if (tabItemTitleLeftBg && tabItemTitleRightBg) {
    return (
      <div
        className={classnames({
          [styles.title]: true,
          [styles['two-bg-title']]: true,
        })}
        style={{ color: tabBarActiveTextColor }}
      >
        <div className={styles['two-img-bg-title']}>
          <img className={styles['both-side-item']} src={tabItemTitleLeftBg} alt="" />
          <div className={styles['title-word']}>{title}</div>
          <img className={styles['both-side-item']} src={tabItemTitleRightBg} alt="" />
        </div>
      </div>
    )
  }
  if (titleBgImgType === 0 && tabItemTitleBg) {
    return (
      <div className={classnames({
        [styles.title]: true,
        [styles['banner-bg-title']]: true,
      })} style={{ color: tabBarActiveTextColor }}>
        <div className={styles['tab-item-title-bg-banner-wrapper']}>
          <img
            className={styles['tab-item-title-bg-banner']}
            src={tabItemTitleBg}
            // data-layzload-src={imgResize(tabItemTitleBg, 200)}
            alt=""
          />
        </div>
        <span style={{ position: 'relative', zIndex: 2 }}>{title}</span>
      </div>
    )
  }
  return (
    <div className={styles.title} style={{ color: tabBarActiveTextColor }}>
      {tabItemTitleBg && (
        <img
          className={styles['tab-item-title-bg']}
          src={tabItemTitleBg}
          // data-layzload-src={imgResize(tabItemTitleBg, 200)}
          alt=""
        />
      )}
      <span style={{ position: 'relative', zIndex: 2 }}>{title}</span>
    </div>
  )
}
